import { Component, Pipe, PipeTransform, Injectable, OnInit } from '@angular/core';
import { Machine } from "../../models/machine";
import { Router } from '@angular/router';
import { MachineService } from "../../services/machine.service";
import { Location } from '@angular/common';


@Pipe({
    name: 'selected',
    pure: false
})

@Injectable()
export class SelectedPipe implements PipeTransform {
    transform(items: any[]): any {
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter(item => item.selected);
    }
}

@Component({
    selector: 'machine-create',
    templateUrl: 'machine-create.component.html',
    styleUrls: ['machine-create.component.css'],
    moduleId: module.id
})

export class MachineCreateComponent {
    constructor(
        private router: Router,
        private machineService: MachineService,
        private location: Location
    ) {}

    machine:Machine = new Machine();

    updateMac() {
        this.machine.macAddress = this.machine.serialNumber.replace(/\./g, ":")
    }


    save(): void {
        this.machineService.addMachine(this.machine).then(machine => {
            this.router.navigate(['dashboard']);
        })
    }

    cancel(): void {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/machine-create/machine-create.component.ts